import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface MaskedValueProps {
  className?: string;
}

export function MaskedValue({ className }: MaskedValueProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={`tracking-[0.3em] text-muted-foreground cursor-default select-none ${className ?? ""}`}
          aria-label="Value restricted for your role"
        >
          •••
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">
        Financial figures are restricted for your role
      </TooltipContent>
    </Tooltip>
  );
}
